import React, { Component } from "react";
import LoadingOverlay from "react-loading-overlay";
import DashboardApi from "../../api/DashboardApi";
import Btn from "../../Components/Btn";
import Sidebar from "../../Components/Sidebar";
import { loaderstyle } from "../../config";

export class ExportCustomers extends Component {
    POLLING_INTERVAL = 5000;

    state = {
        exports: [],
        progress: 0,
        processed: 0,
        count: 0,
        inProgress: false,
    };

    componentDidMount() {
        this.getExportProgress();
        this.getExports();
    }

    createExport = async () => {
        const ctx = this;
        await DashboardApi.exportCustomers().then((result) => {
            const { processed, count } = result.data;
            ctx.setState({
                inProgress: true,
                processed,
                count,
            });

            setTimeout(ctx.getExportProgress, ctx.POLLING_INTERVAL);
        });
    };

    getExports = async () => {
        const ctx = this;
        await DashboardApi.getCustomerExports()
            .then((exports) => {
                ctx.setState({ exports: exports.data });
            })
            .catch((e) => {
                console.error(e);
            });
    };

    deleteExport = async (name) => {
        const ctx = this;
        await DashboardApi.deleteCustomerExport(name).then(ctx.getExports);
    };

    getExportProgress = async () => {
        const ctx = this;
        await DashboardApi.getCustomerExportProgress().then((result) => {
            const { processed, count } = result.data;
            const done = processed >= count;
            if (done) {
                ctx.setState({ inProgress: false });
                ctx.getExports();
            } else {
                ctx.setState({
                    inProgress: true,
                    progress: ((processed / count) * 100).toFixed(2),
                    processed,
                    count,
                });
                setTimeout(ctx.getExportProgress, ctx.POLLING_INTERVAL);
            }
        });
    };

    downloadExport = async (name) => {
        await DashboardApi.downloadExport(name);
    };

    render() {
        const { exports, inProgress, progress, processed, count } = this.state;
        let syncClasses = this.state.syncActive ? "overlay_visible" : "";
        return (
            <div className="wrapper">
                <Sidebar />
                <div className="main-panel">
                    <div className="page-title">
                        <div className="page-title-heading">
                            <h1>
                                Customer Exports{" "}
                                {inProgress
                                    ? `: ${progress}% (${processed}/${count})`
                                    : null}
                            </h1>
                            {/* <Btn className="btn simple" onClick={(event) => { event.preventDefault(); this.toggleSyncClasses() }}><img src="/imgs/icons/sync.png" alt="sync icon" width="12"/>sync</Btn> */}
                            <div
                                className={`overlay overlay-sync ${syncClasses}`}
                            >
                                <p>Syncing Customers …</p>
                            </div>
                        </div>
                        <div className="page-title-actions">
                            <form action="#">
                                <div className="form-field">
                                    <Btn
                                        className="btn simple small"
                                        type="button"
                                        onClick={this.createExport}
                                    >
                                        Export
                                    </Btn>
                                </div>
                            </form>
                        </div>
                    </div>
                    <LoadingOverlay
                        active={this.props.loading}
                        text="Loading..."
                        spinner
                        styles={loaderstyle}
                    >
                        <div className="table-responsive">
                            <table className="basic-table align-left">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Export</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {exports.map((exp, i) => {
                                        return (
                                            <>
                                                <tr>
                                                    <td>{i + 1}</td>
                                                    <td
                                                        style={{
                                                            cursor: "pointer",
                                                        }}
                                                        onClick={this.downloadExport.bind(
                                                            this,
                                                            exp
                                                        )}
                                                    >
                                                        {exp}
                                                    </td>
                                                    <td>
                                                        <i
                                                            class="fa fa-trash"
                                                            onClick={this.deleteExport.bind(
                                                                this,
                                                                exp
                                                            )}
                                                        ></i>
                                                        ;
                                                    </td>
                                                </tr>
                                            </>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </LoadingOverlay>
                </div>
            </div>
        );
    }
}
